<template>
  <div class="hello">
    <!-- <div class="top">
      <img src="@/assets/gs-banner.jpg" alt="顶部广告" class="top-img">
    </div> -->
    <Header></Header>


    <div class="content_s clearfix">
      <el-row>
        <el-col>
          <div class="last-act clearfix">
            <div class="last-actl">
              <el-carousel height="406px" ref="carousel" @click.native="linkTo">
                <el-carousel-item v-for="(item,index) in carouselData" v-bind:key="index">
                  <img :src="item.image_url" alt="轮播图1">
                  <h3 class="small">{{ item.title }}</h3>

                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="last-actr">
              <el-divider>活动合作</el-divider>
              <div class="tel-list">

                <h3>
                  <span>领袖年会筹备组</span>
                </h3>
                <p>商务合作：010-59512929</p>
                <p>参会报名：010-59512952</p>
                <p>媒体报名：010-59512974</p>
                <h3>
                  <span>木兰汇</span>
                </h3>
                <p>咨询电话：010-59512951</p>
                <p>　　　　　16818461662</p>
                <h3>
                  <span>未来之星</span>
                </h3>
                <p>咨询电话：010-58034009</p>
                <p>　　　　　16631095998</p>
                <h3>
                  <span>“专精特新”企业家论坛</span>
                </h3>
                <p>咨询热线：010-58034009</p>
                <p>　　　　　13811357521</p>

                <h3> <span>中国企业家俱乐部</span></h3>
                <p>咨询热线：18210905375</p>
              </div>
            </div>
          </div>

        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="mag-list">
            <div class="time-title">
             
                <el-tabs v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane v-for="(au,index) in columnData" :key="index" :label="au.column_name" :name="au.id+'-name'"></el-tab-pane>
                </el-tabs>
              
            </div>
            <div class="item-mag">
              <el-row>
                <el-col :span="8" v-for="(o, index) in activityData" :key="index">
                  <el-card :body-style="{ padding: '0px 13px 50px',cursor:'pointer'}" @click.native="rediect_toshemb(o.redirect_url)">
                    <img :src="o.image_url" class="image">
                    <div style="padding: 0px;" class="act-info" >
                      <h3>{{o.title}}</h3>
                      <span>活动日期：{{o.start_date}}</span>
                      <span>地   点：{{o.place}}</span>
                      <div @click="redirect_to(o.register_url)"     class="state-begin" v-if="o.is_complate == '1'">
                        报名中
                      </div>
                      <div class="state-end" v-else @click="redirect_to(2)">
                        报名结束
                      </div>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </div>
          <!-- 提示文字 -->
            <el-empty description="暂无内容" v-show="status"></el-empty>
          </div>
        </el-col>
      </el-row>
     
    </div>



    <bbottom></bbottom>

  </div>

</template>

<script>

  import Header from "@/components/public/Header.vue"
  import bbottom from "@/components/public/bbottom.vue"
  export default {
    name: 'Active',

    data() {
      return {
        fullscreenLoading: false,
        activeName: '6-name',
        // 轮播图
        carouselData: [],
        // 栏目频道
        columnData: [],
        activityData:[],
        status:false
      }
    },

    props: {},

    created(){
       this.getactivityInfo()
       this.getActivity()
       this.getActivityColumnInfo()
    },

    //页面初始化
    computed: {

    },

    //页面加载后执行方法

    methods: {

      getActivityColumnInfo(){

        var config = {
          method: 'GET',
          url: '/api/v1/activity/column/list',
          headers: { 
            'Content-Type': 'application/json'
          }
        };
            
        this.$axios(config).then(res=>{

          this.$data.columnData = res.data
          console.log('请求成功')
          
        }).catch(error=>{
          console.log('请求失败')
        })

      },
      redirect_to(tourl){
        if (tourl =='2'){

          this.$message({
            message:'本期活动已结束,感谢您的支持！',
            type:'error',
            duration:2000,
            customClass: 'messageIndex'
          })

        }else{
            window.open(tourl)
        }

          
      },

      linkTo(){
        let activeIndex = this.$refs.carousel.activeIndex
        // console.log(activeIndex)
        // this.$router.push({path:this.$data.carouselData[activeIndex].redirect_url})
        window.open(this.carouselData[activeIndex].redirect_url)
      },

      getactivityInfo(){
        var config = {
          method: 'GET',
          url: '/api/v1/activity/bannerlist',
          headers: { 
            'Content-Type': 'application/json'
          }
        };
            
        this.$axios(config).then(res=>{

          this.$data.carouselData = res.data
          console.log('请求成功')
          
        }).catch(error=>{
          console.log('请求失败')
        })
      },

      handleClick(tab, event){
        // column_id = tab.splite()
        var tabid = tab.name.split('-')[0]
        if (tabid ==6){
            tabid = 0
        } 
        this.getActivity(tabid)

      },

      getActivity(actid=0){
        var config = {
          method: 'GET',
          url: '/api/v1/activity/list/'+actid,
          headers: { 
            'Content-Type': 'application/json'
          }
        };
            
        this.$axios(config).then(res=>{


          console.log(res.data.length)
          if(res.data.length <= 0)
          {
            this.$data.activityData = res.data
            this.$data.status = true
          }else{
             this.$data.activityData = res.data
             this.$data.status = false
            console.log('请求成功')
          }
         
        }).catch(error=>{
          console.log('请求失败')
        })
      },
      rediect_toshemb(redirect_url){
        window.open(redirect_url)
      }


    },
    //组件引入
    components: {

      Header,
      bbottom
    },
  }

</script>

<style>

.messageIndex {
  z-index: 19999 !important;
}
.mag-list .el-empty__description p {
    margin: 0;
    font-size: 20px !important;
    font-family:Arial, Helvetica, sans-serif;
    font-weight:600;
  }
</style> 

<style scoped>



  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .content_s {
    width: 1200px;
    margin: 25px auto;
    color: #4b4b4b;
  }

  .img_s {
    width: 100%;
    border-radius: 6px;
  }

  .top {
    width: 1200px;
    margin: 0 auto;
  }

    .top img {
      display: block
    }

  
  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
    border-radius:6px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .item h3 {
    color: #e85a50;
  }

  .icon_s {
    display: inline-block;
    width: 30px;
    height: 30px;
    background: #eea01e;
    text-align: center;
    line-height: 30px;
    border-radius: 10px;
    margin-right: 15px;
    /* color:#fa5c00; */
    color: white;
  }

  .text {
    font-size: 14px;
  }

  .item {
    padding: 18px 0;
  }

  .box-card {
    width: 100%;
    margin-bottom: 20px;
  }

  .el-row {
    margin-bottom: 0px;
  }

  .el-col {
    /* margin-right:30px; */
    border-radius: 4px;
  }

  
  .el-icon-caret-right:before {
    color: #bd0c16 !important;
    font-size: 16px !important;
    line-height: 20px
  }

  .mag-r .act-list .el-icon-caret-right:before {
    color: #bd0c16 !important;
    font-size: 30px !important;
    line-height: 30px
  }

  .el-button--default {
    background-color: #bd0c16;
    width: 130px;
    height: 40px;
    color: #ffffff;
    font-size: 18px;
    margin-top: 30px;
  }

  .mag-list {
    width: 1200px;
    margin: 30px auto;
  }

  .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    font-size: 18px !important;
    font-weight: normal !important;
  }

  .time-title {
    width: 100%;
    height: 50px;
    border: 1px solid #f1f1f1;
    border-left-width: 0px;
    border-right-width: 0px;
    line-height:50px;
  }
  .last-act{
    width:1200px;
    height:406px;
    margin:0 auto;
  }
  .last-actl {
    width: 825px;
    height:406px;
    float: left;
    overflow:hidden;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    cursor: pointer;
  }
    .last-actl img{
      border-top-left-radius:6px;
      border-bottom-left-radius:6px;
    }
  .last-actr {
    width: 305px;
    padding: 20px 35px;
    height: 366px;
    background-color: #f1f1f1;
    float: left;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }
  .el-divider{
    background-color:#bd0c16;
  }
  .el-divider--horizontal{
    height:3px;
  }
  .el-divider__text{
    background-color:#f1f1f1;
    padding:0px 10px;
    font-size:18px;
    color:#4b4b4b;
  }
  .time-title h2 {
    width: 120px;
    background-color: #bd0c16;
    font-size: 22px;
    color: #fff;
    display: inline-block;
    float: left;
    margin: 0px;
    line-height: 50px;
    text-align: center;
    font-weight: normal;
    height: 50px;
  }

  .year-list {
    width: 1020px;
    display: inline-block;
    margin: 0px 30px;
    float: left;
  }

  .item-mag {
    margin: 25px auto;
  }

    .item-mag .el-card {
      border: none;
      box-shadow: none;
    }

  .el-card {
    color: #4b4b4b !important;
  }

    .el-card h3 {
      margin: 0px;
      padding: 8px 2px 15px;
      font-size: 16px;
      line-height: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      height: 48px;
    }

    .el-card span {
      font-size: 14px;
      color: #999;
      display:block;
      line-height:20px;
    }
  .el-carousel__item h3 {
    margin: 0;
    position: absolute;
    bottom: 30px;
    line-height: 30px;
    font-size: 24px;
    color: #fff;
    padding: 0px 25px;
    font-weight: normal
  }

  .elter img {
    border-radius: 6px;
    width: 100%;
  }
  .act-info{
    position:relative;
  }
    .act-info .state-begin, .act-info .state-finish {
      position: absolute;
      right: 2px;
      bottom: 0px;
      display: block;
      padding: 2px 8px;
      background-color: #bd0c16;
      border:1px solid #bd0c16;
      color: #fff;
      border-radius: 10px;
      font-size: 12px;
      line-height: 16px;
      cursor:pointer;
    }

    .act-info .state-end{
      position: absolute;
      right: 2px;
      bottom: 0px;
      display: block;
      padding: 2px 8px;
      background-color: #383737;
      border:1px solid #383737;
      color: #fff;
      border-radius: 10px;
      font-size: 12px;
      line-height: 16px;
      cursor:pointer;
    }
    .act-info .state-finish {
      background-color: #f1f1f1;
      border:1px solid #999;
      color: #4b4b4b;
    }
  .tel-list{
    height:280px;
    overflow-y:scroll;
  }
    .tel-list::-webkit-scrollbar {
      width: 8px;
    }

  .tel-list::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #ccc;
  }

 

  .tel-list h3 {
    display: block;
    margin: 15px auto 0px;
  }
  .tel-list h3 span{
    display:inline-block;
    height:20px;
    padding:2px;
    background-color:#ddd;
    font-size:14px;
    line-height:20px;
    color:#bd0c16;
  }
  .tel-list p{
    margin:0px;
    line-height:22px;
  }
</style>



// WEBPACK FOOTER //
// src/components/activity.vue